var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(!_vm.verificationComplete)?_c('h2',{staticClass:"primary--text mt-16 text-center"},[_vm._v(" Verifying... ")]):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }